import React from 'react';
import { Modal } from 'react-bootstrap';
import { PreferentialTooltip } from '../../ProductInfo/Tooltips';
import { Input } from '../../../Input/Input';

const IpaffsModalHeader = ({ certificateCount, setCertificateCount, readOnly = false }) => {
  const handleKeyDown = (e) => {
    if (readOnly) {
      e.preventDefault();
      return;
    }

    const key = e.keyCode;
    // Allow only numbers, backspace, delete, tab, arrow keys, and up/down arrows
    if (
      !(
        (key >= 48 && key <= 57) || // Numbers 0-9 (regular keyboard)
        (key >= 96 && key <= 105) || // Numbers 0-9 (numpad)
        key === 8 || // Backspace
        key === 46 || // Delete
        key === 9 || // Tab
        key === 37 || // Left arrow
        key === 39 || // Right arrow
        key === 38 || // ArrowUp
        key === 40 // ArrowDown
      )
    ) {
      e.preventDefault();
    }
  };

  const handleBlur = (e) => {
    if (!readOnly && setCertificateCount) {
      const value = e.target.value;
      if (value === '') setCertificateCount('0');
    }
  };

  const handleChange = (e) => {
    if (!readOnly && setCertificateCount) {
      let value = e.target.value;

      if (value !== '' && (value < 0 || value > 99)) {
        value = Math.max(0, Math.min(99, value));
      }

      setCertificateCount(value);
    }
  };

  return (
    <Modal.Header style={{ display: 'block' }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          justifyContent: 'space-between',
        }}
      >
        <Modal.Title
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          IPAFFS Risk Categorisation{' '}
          <PreferentialTooltip optionalSize="1.5rem">
            <p>
              {
                "List below shows commodities from 'Risk Categories' that are blank in the Health Cert column or have the value 'Low', 'Medium', or 'High' or contain 'CHED'"
              }
            </p>
          </PreferentialTooltip>
        </Modal.Title>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto auto',
            alignItems: 'center',
            columnGap: '20px',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto auto',
              alignItems: 'center',
              columnGap: '5px',
              background: certificateCount != 0 ? '#C8E1CE' : '#FFBE00',
              borderRadius: '5px',
              padding: '6px',
              fontWeight: 'bold',
              justifyContent: 'space-between',
              height: '85%',
            }}
          >
            <label htmlFor="certificateQty" className="me-2 mb-0">
              Certificate Count
            </label>
            <PreferentialTooltip optionalSize="1.5rem">
              <p>This will help you work out how many IPAFFS are required per shipment.</p>
            </PreferentialTooltip>
          </div>
          <Input
            type="number"
            name="certificateQty"
            label="CertificateQuantity"
            hideLabel={true}
            min="0"
            max="99"
            value={certificateCount}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            disabled={readOnly}
          />
        </div>
      </div>
    </Modal.Header>
  );
};

export default IpaffsModalHeader;
